/**
 * Spanish Translations
 *
 * This file contains all Spanish translations for the application.
 * It extends React Admin's default Spanish translations.
 */

import spanishMessages from 'ra-language-spanish';

// Feature translations
import { authEs } from '@/features/auth/i18n';
import { accountsEs } from '@/features/accounts/i18n';
import { testEs } from '@/features/test/i18n';
import { creditConsumptionEs } from '@/features/credit-consumption/i18n';
import { costCenterEs } from '@/features/cost-center/i18n';
import { pricingEs } from '@/features/pricing/i18n';
import { creditBalanceEs } from '@/features/credit-balance/i18n';
import { creditTransactionEs } from '@/features/credit-transaction/i18n';
import { creditEventLogsEs } from '@/features/credit-event-logs/i18n';
import { creditEventSummaryEs } from '@/features/credit-event-summary/i18n';
import { userManagementEs } from '@/features/user-management/i18n';
import { platformUsersEs } from '@/features/platform-users/i18n';
import { scheduledJobsEs } from '@/features/scheduled-jobs/i18n';
import { statisticsEs } from '@/features/statistics/i18n';
import { notificationLogsEs } from '@/features/notification-logs/i18n';
import { applicationsEs } from '@/features/applications/i18n';
import { licensesEs } from '@/features/licenses/i18n';
import { providersEs } from '@/features/providers/i18n';
import { defaultPricingEs } from '@/features/default-pricing/i18n';
import { manageGroupsEs } from '@/features/manage-groups/i18n';
import { backupEs } from '@/features/backup/i18n';
import { userProfileEs } from '@/features/user-profile/i18n';

const customSpanishMessages = {
  ...spanishMessages,

  common: {
    no_data_title: 'No hay datos',
    no_data_description: 'No hay registros para mostrar.',
    loading: 'Cargando...',
    error: 'Ha ocurrido un error',
    success: 'Operacion completada con exito',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    filter: 'Filtrar',
    clear: 'Limpiar',
    yes: 'Si',
    no: 'No',
    coming_soon: 'Proximamente',
    phone: {
      prefix: 'Prefijo',
      number: 'Número',
    },
    deleteConfirmTitle: 'Estas seguro de eliminar?',
    deleteConfirmSubtitle: 'Esta accion no se puede deshacer',
    ok: 'OK',
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
      pending: 'Pendiente',
    },
  },

  menu: {
    overview: 'Resumen',
    groups: {
      administration: 'Administración',
    },
  },

  auth: {
    session: 'Sesión',
    session_expired: 'Sesión caducada',
  },

  pages: {
    login: {
      ...authEs,
      title: 'Bienvenido',
      subtitle: 'Inicia sesion en tu cuenta',
      login_button: 'Iniciar Sesion',
      forgot_password: 'Olvidaste tu contrasena?',
    },
    dashboard: {
      title: 'Panel de Control',
      welcome: 'Bienvenido de nuevo',
    },
    settings: {
      title: 'Ajustes',
      configuration: 'Configuración',
      configurationIntro: 'Elige una sección de configuración en el menú.',
      defaultParameters: 'Parámetros por defecto',
      defaultParametersIntro: 'Parámetros por defecto de la plataforma.',
    },
  },

  resources: {
    accounts: accountsEs,
    // RA's resource name is `apps/accounts`; alias the i18n bundle so
    // lookups like `resources.apps/accounts.notifications.deleted`
    // resolve to the same translations as `resources.accounts.*`.
    'apps/accounts': accountsEs,
    test: testEs,
    'credit-consumption': creditConsumptionEs,
    'credit-consumption/cost-center': costCenterEs,
    'credit-consumption/pricing': pricingEs,
    'credit-consumption/credit-balance': creditBalanceEs,
    'credit-consumption/credit-transaction': creditTransactionEs,
    'credit-consumption/credit-event-logs': creditEventLogsEs,
    'credit-consumption/credit-event-summary': creditEventSummaryEs,
    'user-management': userManagementEs,
    'platform-users': platformUsersEs,
    'scheduled-jobs': scheduledJobsEs,
    statistics: statisticsEs,
    'notification-logs': notificationLogsEs,
    applications: applicationsEs,
    licenses: licensesEs,
    providers: providersEs,
    'default-pricing': defaultPricingEs,
    'manage-groups': manageGroupsEs,
    backup: backupEs,
  },

  // Top-level namespace for non-Resource features (custom routes).
  'user-profile': userProfileEs,

  validation: {
    required: 'Este campo es obligatorio',
    email: 'Por favor, introduce un email valido',
    minLength: 'Debe tener al menos %{min} caracteres',
    maxLength: 'No puede tener mas de %{max} caracteres',
    number: 'Debe ser un numero valido',
    positive: 'Debe ser un numero positivo',
    nonNegative: 'Debe ser 0 o mayor',
    unique: 'Este valor ya existe',
  },

  notifications: {
    session_expired: 'Tu sesion ha expirado. Por favor, inicia sesion de nuevo.',
    connection_error: 'Error de conexion. Por favor, comprueba tu conexion a internet.',
    server_error: 'Error del servidor. Por favor, intentalo de nuevo mas tarde.',
  },
};

export default customSpanishMessages;
